module.exports = __webpack_public_path__ + "Xplora_Symbol_Red_RGB.png?3f0b46ba87d48bb673febbe139c02652";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Xplora_Symbol_Red_RGB.png
// module id = 22
// module chunks = 4